import { styled } from '@material-ui/core/styles'

export const Form = styled('form')({
  paddingBottom: 40,
  width: '100%',
})
